import React from "react";

import { type InstallationScriptDetails } from "@north-beam/nb-common";

import { TrackingScriptCard } from "./tracking-script-card";

interface TrackingScriptTagsProps {
  installationScripts: InstallationScriptDetails;
  startExpanded?: boolean;
}
export const ShopifyPostPurchaseUpsellTag = ({
  installationScripts,
  startExpanded,
}: TrackingScriptTagsProps): React.ReactElement => (
  <TrackingScriptCard
    displayName="Shopify: Post-purchase upsell page"
    header={
      "If you use Post-Purchase on Shopify, please follow the instructions below to add the " +
      "post-purchase pixel."
    }
    scriptCode={installationScripts.shopify_post_purchase_upsell_pixel}
    startExpanded={startExpanded}
    descriptionHTML={
      <>
        <p>
          <b>Installation instructions</b>
        </p>
        <p>Only place this pixel if you use one-click upsell. </p>
        <ol>
          <li>
            <b>
              Only follow these instructions if use Shopify to upsell customers
              after checkout.
            </b>
          </li>
          <li>
            Click the button above to copy this script code to your clipboard.
          </li>
          <li>Go to your Shopify admin panel.</li>
          <li>
            Click on <b>Settings</b> in the bottom left hand corner.
            <div style={{ maxWidth: 800 }}>
              <img
                src="//static.northbeam.io/images/shopify-navigate-to-settings.png"
                className="img-fluid p-3"
                alt="Shopify navigate to settings instructions"
              />
            </div>
          </li>
          <li>
            Click on <b>Checkout</b> once you are on the Settings page.
            <div style={{ maxWidth: 800 }}>
              <img
                src="//static.northbeam.io/images/shopify-navigate-to-checkout.png"
                className="img-fluid p-3"
                alt="Shopify navigate to checkout instructions"
              />
            </div>
          </li>
          <li>
            Scroll down to the <b>Post-purchase page</b> section, and paste the
            code (from step 1) in the <b>Additional Scripts</b> section.
            <div style={{ maxWidth: 800 }}>
              <img
                src="https://storage.googleapis.com/static.northbeam.io/images/shopify-post-purchase-additional-scripts"
                className="img-fluid p-3"
                alt="Shopify post-purchase section highlight"
              />
            </div>
          </li>
        </ol>
      </>
    }
  />
);
